import * as React from 'react';
import PropTypes from 'prop-types';
// material
import { Card, Box, Button } from '@mui/material';
import ViewHistoryDataGrid from './ViewHistoryDataGrid';
import ModalPopup from '../../../components/modal-popup/modalpopup';
// --------------------------------------------------------------------------------------------------------

ViewHistoryPopup.propTypes = {
    confirm: PropTypes.func,
    columnData: PropTypes.array,
    rowData: PropTypes.object,
    masterName: PropTypes.string,
};
// --------------------------------------------------------------------------------------------------------

export default function ViewHistoryPopup({ confirm, masterName, columnData, rowData }) {

    const onClickOk = () => {
        confirm(true)
    };

    const onClickNo = () => {
        confirm(false);
    };

    return (
        <div>
            <ModalPopup cancel={onClickNo} sx={{ height: 480 }} >
                <Card sx={{ height: 365 }}>
                    <ViewHistoryDataGrid columnData={columnData} masterName={masterName} masterRowData={rowData} />
                </Card>
                <Box sx={{ position: 'absolute', bottom: 16, right: 16 }}>
                    <Button variant="contained" onClick={onClickOk} value='true' > Ok  </Button>
                </Box>
            </ModalPopup>
        </div >
    )
}